import TaskList from "../components/dashboard/TaskList";

export default function Tasks() {
  return (
    <div className="w-full">
      <TaskList />
    </div>
  );
}
